// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#update-available .update-message {
  margin: 0.5rem 0 1rem;
  text-align: center;
}

#update-available .update-button {
  font-size: 1.8rem;
  margin: 0.5rem;
  color: white;
  border-radius: 999px;
  padding: 0.5rem 0.5rem;
  cursor: pointer;
}

#update-available .reload {
  font-size: 1.2rem;
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateAvailableModal.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,wCAAwC;AAC1C","sourcesContent":["#update-available .update-message {\n  margin: 0.5rem 0 1rem;\n  text-align: center;\n}\n\n#update-available .update-button {\n  font-size: 1.8rem;\n  margin: 0.5rem;\n  color: white;\n  border-radius: 999px;\n  padding: 0.5rem 0.5rem;\n  cursor: pointer;\n}\n\n#update-available .reload {\n  font-size: 1.2rem;\n  background-color: var(--secondary-color);\n  border: 2px solid var(--secondary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
